import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'About Us', path: '/about' },
      { label: 'Services', path: '/services' },
      { label: 'Contact', path: '/contact' }
    ],
    services: [
      { label: 'Food Consultancy', path: '/services#food' },
      { label: 'Finance Consultancy', path: '/services#finance' },
      { label: 'HACCP Implementation', path: '/services#haccp' }
    ]
  };

  return (
    <footer style={{ backgroundColor: 'var(--color-white)', color: 'var(--color-navy)' }}>
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img
              src="/prime-logo.png?v=2"
              alt="Prime Food & Financial Consultancy"
              className="h-[154px] w-auto object-contain mb-4"
              data-testid="footer-logo"
            />
            <p className="text-sm leading-relaxed opacity-80">
              Empowering Growth. Building Success. Expert consultancy services for food businesses and financial planning.
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ color: 'var(--color-navy)' }}>Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm opacity-80 hover:opacity-100 transition-opacity"
                    style={{ color: 'var(--color-navy)' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ color: 'var(--color-navy)' }}>Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm opacity-80 hover:opacity-100 transition-opacity"
                    style={{ color: 'var(--color-navy)' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ color: 'var(--color-navy)' }}>Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 flex-shrink-0" style={{ color: 'var(--color-emerald)' }} />
                <span className="text-sm opacity-80" style={{ color: 'var(--color-navy)' }}>The Netherlands</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="mt-1 flex-shrink-0" style={{ color: 'var(--color-emerald)' }} />
                <span className="text-sm opacity-80" style={{ color: 'var(--color-navy)' }}>anushivi18@gmail.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="mt-1 flex-shrink-0" style={{ color: 'var(--color-emerald)' }} />
                <span className="text-sm opacity-80" style={{ color: 'var(--color-navy)' }}>+31 621660865</span>
              </li>
            </ul>
          </div>

          {/* Registration Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ color: 'var(--color-navy)' }}>Registration</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-sm block font-medium" style={{ color: 'var(--color-navy)' }}>KVK-number</span>
                <span className="text-sm opacity-80" style={{ color: 'var(--color-navy)' }}>42121464</span>
              </li>
              <li>
                <span className="text-sm block font-medium" style={{ color: 'var(--color-navy)' }}>VAT ID (btw-id)</span>
                <span className="text-sm opacity-80" style={{ color: 'var(--color-navy)' }}>NL005510841859</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-8 mt-8" style={{ borderColor: 'rgba(10, 24, 40, 0.1)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm opacity-60" style={{ color: 'var(--color-navy)' }}>
              © {currentYear} Prime Food & Financial Consultancy. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <motion.a
                whileHover={{ scale: 1.1 }}
                href="#"
                className="opacity-60 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--color-navy)' }}
              >
                <Linkedin size={20} />
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
